// FETCH ALL ALL_OVER_PRINTING INWARD_DC
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE';

// CREATE ALL_OVER_PRINTING INWARD_DC
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST';
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS';
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE';

// UPDATE ALL_OVER_PRINTING INWARD_DC
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST';
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS';
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF ALL_OVER_PRINTING INWARD_DC
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE';

// DELETE ALL_OVER_PRINTING INWARD_DC
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST';
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS';
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_FAILURE';

export const RESET_ALL_OVER_PRINTING_DC_INWARD_MASTER_INFO = 'RESET_ALL_OVER_PRINTING_DC_INWARD_MASTER_INFO';

export const CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM';

export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS = 'NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS';

// NAVIGATE TO ALL_OVER_PRINTING INWARD_DC COMPONENT
export const NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_MASTER = 'NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_MASTER';

export const RESET_FORM_DATA_WITHOUT_ALL_OVER_PRINTING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_ALL_OVER_PRINTING_INWARD_ID';
export const SET_ACTIVE_KEY_ALL_OVER_PRINTING_INWARD = 'SET_ACTIVE_KEY_ALL_OVER_PRINTING_INWARD';

export const SET_UNIT_NAME_ALL_OVER_PRINTING_DC_INWARD = 'SET_UNIT_NAME_ALL_OVER_PRINTING_DC_INWARD';
export const SET_START_DATE_ALL_OVER_PRINTING_DC_INWARD = 'SET_START_DATE_ALL_OVER_PRINTING_DC_INWARD';
export const SET_END_DATE_ALL_OVER_PRINTING_DC_INWARD = 'SET_END_DATE_ALL_OVER_PRINTING_DC_INWARD';
